var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticStyle:{"max-height":"100vh","max-width":"100vw"}},[(!_vm.loggedIn)?_c('login'):_c('main-screen'),_c('snack')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }